import { useState } from "react";
import Select from "../../../components/Select/Select";
import Input from "../../../components/Input/Input";
import { useFastCondoUserStore } from "./context";
import { useTranslation } from "react-i18next";

export function AccessStep() {
   const {
      permanencyTime,
      customEndDate,
      info,
      errors,
      isSubmitting,
      update
   } = useFastCondoUserStore();

   const { t } = useTranslation();

   return (
      <div className="w-[90%]! mx-auto!">
         <div className={`grid ${permanencyTime === 9 ? 'grid-cols-2' : 'grid-cols-1'} gap-4`}>
            <Select
               labelText={t("monitoring.permanencyTime")}
               value={`${permanencyTime}`}
               onChange={({ target }) => {
                  update("permanencyTime", Number(target.value))
               }}
               required={false}
               options={[
                  { value: 0, text: t("monitoring.noControlPermanencyTime") },
                  { value: 1, text: t("monitoring.minutesPermanencyTime", { minutes: 10 }) },
                  { value: 2, text: t("monitoring.minutesPermanencyTime", { minutes: 20 }) },
                  { value: 3, text: t("monitoring.minutesPermanencyTime", { minutes: 30 }) },
                  { value: 4, text: t("monitoring.oneHourPermanencyTime") },
                  { value: 5, text: t("monitoring.hoursPermanencyTime", { hours: 3 }) },
                  { value: 6, text: t("monitoring.hoursPermanencyTime", { hours: 6 }) },
                  { value: 7, text: t("monitoring.hoursPermanencyTime", { hours: 12 }) },
                  { value: 8, text: t("monitoring.oneDayPermanencyTime") },
                  { value: 9, text: t("monitoring.otherPermanencyTime") },
               ]}
               disabled={isSubmitting}
            />
            {permanencyTime === 9 && (
               <Input
                  labelText={t("monitoring.endDate")}
                  value={customEndDate}
                  onChange={({ target }) => {
                     update("customEndDate", target.value)
                  }}
                  required={true}
                  type="datetime-local"
                  disabled={isSubmitting}
                  error={errors.customEndDate?.join('. ')}
               />
            )}
            <div className={`${permanencyTime === 9 ? 'col-span-2' : 'col-span-1'}`}>
               <Input
                  labelText={t("monitoring.additionalInfo")}
                  value={info}
                  onChange={({ target }) => {
                     update("info", target.value)
                  }}
                  required={true}
                  type="text"
                  disabled={isSubmitting}
               />
            </div>
         </div>
      </div>
   );
}